import React from 'react';

import { SEOPageLinkPType, SEOPageTabLink } from '@helpers/SEOPagesHelpers';

const formatTowns = ({
  list,
  ptypeForLinks,
  withEm = true,
  withUl = true,
}) => {
  const towns = list.map(
    (town) => {
      const title = town.name.replace(/\-/g, ' ');
      const linkTitle = `Guarda ${ptypeForLinks} a ${title}`;
      const { count } = town;
      const { href } = town;
      const aLabel = `Immobili a ${title}. Al momento sono ${count.replace(/\./g, '')} risultati`;
      return (
        <li key={title}>
          <a
            href={href}
            title={linkTitle}
            data-count={count}
            aria-label={aLabel}
            className="tp-s--l tp-w--m tp--u c-txt--f2"
          >
            <span>{title}</span> {withEm && (<em>(comune)</em>)}
          </a>
        </li>
      );
    },
  );
  return withUl ? <ul>{towns}</ul> : towns;
};

const formatProvinces = (list, ptypeForLinks) => {
  const provinces = list.map(
    (province) => {
      const title = province.name.replace(/\-/g, ' ');
      const linkTitle = `Guarda ${ptypeForLinks} nella provincia di ${title}`;
      const { count, href } = province;
      const towns = 'towns' in province ? formatTowns({
        list: province.towns,
        ptypeForLinks,
        withEm: true,
      }) : null;
      const aLabel = `Immobili nella provincia di ${title}. Al momento sono ${count.replace(/\./g, '')} risultati`;
      const link = towns
        ? (
          <a
            href={href}
            title={linkTitle}
            data-count={count}
            aria-label={aLabel}
            className="tp-s--l tp-w--m tp--u c-txt--f2"
          >
            <span>{title}</span> <em>(provincia)</em>
          </a>
        ) : (
          <a
            href={href}
            title={linkTitle}
            data-count={count}
            aria-label={aLabel}
            className="tp-s--l tp-w--m tp--u c-txt--f2"
          >
            <span>{title}</span>
          </a>
        );
      return (
        <dd key={title}>
          {link}
          {towns}
        </dd>
      );
    },
  );
  return provinces;
};

export const formatSeoList = (list, ptypeForLinks, device) => {
  const formatted = Object.keys(list).map(
    (region) => {
      const title = region;
      return (
        <dl key={title}>
          <dt aria-label={`Immobili della regione ${title}`}>
            {title}
          </dt>
          {formatProvinces(list[title].provinces, ptypeForLinks)}
        </dl>
      );
    },
  );
  const list1 = [];
  const list2 = [];
  const list3 = [];
  const list4 = [];
  if (device !== 'tablet') {
    formatted.forEach(
      (el, index) => {
        if (index < 6) {
          list1.push(el);
        } else if (index < 11) {
          list2.push(el);
        } else if (index < 15) {
          list3.push(el);
        } else {
          list4.push(el);
        }
      },
    );
  } else {
    formatted.forEach(
      (el, index) => {
        if (index < 7) {
          list1.push(el);
        } else if (index < 13) {
          list2.push(el);
        } else {
          list3.push(el);
        }
      },
    );
  }
  return {
    list1,
    list2,
    list3,
    list4,
  };
};

export const formatAllSeoList = ({ seoFooter, device }) => {
  const obj = {
    default: {},
    ptypes: {},
    nRooms: {},
  };
  Object.keys(seoFooter).map((firstKey) => {
    Object.keys(seoFooter[firstKey]).map((secondKey) => {
      const val = seoFooter[firstKey][secondKey];
      let ptypeForLinks = 'Case';
      if (firstKey === 'ptypes') {
        ptypeForLinks = SEOPageLinkPType({
          ptype: secondKey,
          numRooms: '',
        });
      } else if (firstKey === 'nRooms') {
        ptypeForLinks = SEOPageLinkPType({
          ptype: true,
          numRooms: secondKey,
        });
      }
      obj[firstKey][secondKey] = formatSeoList(val, ptypeForLinks, device);
    });
  });
  return obj;
};

export const chooseTab = ({ isAgencyHome, channel, onlyAuction }) => {
  let tab = 'buy';
  if (isAgencyHome) {
    tab = 'agency';
  } else if (onlyAuction) {
    tab = 'auction';
  } else if (channel === 'affitto') {
    tab = 'rent';
  }
  return tab;
};

export const chooseTabLink = ({
  isAgencyHome,
  propertyTypeGroup,
  ptype,
  numRooms,
  condition,
  onlyAuction,
}) => (!isAgencyHome && !onlyAuction) ? SEOPageTabLink(propertyTypeGroup, ptype, numRooms, condition) : '';


export const createSeoFooterForBigCities = ({ list, ptypeForLinks = '' }) => formatTowns({
  list,
  ptypeForLinks,
  withEm: false,
  withUl: false,
});
